import { render, staticRenderFns } from "./ErrorController.vue?vue&type=template&id=4fee9022"
import script from "./ErrorController.vue?vue&type=script&lang=js"
export * from "./ErrorController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports